// removed by extract-text-webpack-plugin
module.exports = {"file-open-button":"_1-xUER7pT-hiBFcAeqCbw5","file-open-button__input":"ZqOLmfHsWAJMo2XJikNrZ"};